import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextInput } from '../../../../../../../common/inputs/textInput/TextInput'
import { useFormState } from '../../../../../wizard/useFormState'
import { ContentStateProperty } from '../../../../../../../../@types/types'
import { isWebView } from '../../../../../../../../utils/navigation'

export interface RentalIncomeProps {
  screenId: string
  rentalIncome?: string
  rentalIncomeValidation: string[]
  onChange: (property: ContentStateProperty, value: string | undefined) => void
}

const RentalIncomeField: React.FC<RentalIncomeProps> = ({ rentalIncome, rentalIncomeValidation, onChange }) => {
  const { formState } = useFormState()
  const isMobileView = isWebView()
  const { t } = useTranslation()

  const showErrors = () =>
    rentalIncomeValidation.length > 0 && (formState.submitCount > 0 || formState.touched.rentalIncome)

  return (
    <div className='inline-block margin-top-m one-whole'>
      {!isMobileView && (
        <div className='inline-block vertical-center-container'>
          <span className='vertical-center lap-margin-left-m desk-margin-left-m margin-left-xxl path-symbol-before' />
        </div>
      )}
      <div
        className={`${isMobileView ? 'one-whole margin-top-l' : 'inline-block desk-seven-twelfths lap-eight-twelfth palm-ten-twelfth'}`}
      >
        <TextInput
          id='rental-income-field'
          propertyName='rentalIncome'
          placeholder={!isMobileView ? t('wizard.screen.otherFacilities.rentalIncomeField', 'Rental income') : ''}
          label={isMobileView ? t('wizard.screen.otherFacilities.mobileRentalIncomeField', 'Rental income') : undefined}
          unitRight={isMobileView ? 'eur' : 'none'}
          affixRight='unit'
          value={rentalIncome}
          type='text'
          errors={[]}
          showRedBoarder={rentalIncomeValidation.length > 0}
          doOnFieldChange={(property, value) => onChange(property, value !== '' ? value : undefined)}
        />
      </div>
      {showErrors() && (
        <span
          role='alert'
          className='input-label-helper-text font-error'
          aria-label={t('wizard.screen.otherFacilities.rentalIncomeField', 'Rental income')}
        >
          {t(`validation.${rentalIncomeValidation[0]}`)}
        </span>
      )}
    </div>
  )
}

export default RentalIncomeField
